var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',{staticClass:"list-ul"},_vm._l((_vm.items),function(item,index){return _c('li',{key:index,on:{"click":function($event){_vm.selectingIndex = index}}},[_c('div',{staticClass:"check-circle",class:{'active': _vm.selectingIndex === index}}),_c('p',{staticClass:"check-title"},[_vm._v(_vm._s(item))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }